import { useNavigate } from "react-router-dom";
import styles from "./engajamento.module.css";
import { AuthContext } from "../../context/AuthContext";
import { useContext, useState } from "react";
import BottomNav from "../../components/BottomNav";


export default function Engajamento() {
    const navigate = useNavigate();
    const { user } = useContext(AuthContext);

    function abrirLink(url) { window.open(url, "_blank"); fechar(); }
    function fechar() { setMenuOpen(false); }
    const [menuOpen, setMenuOpen] = useState(false);

    const menus = [
        {
            titulo: "Registrar",
            descricao: "Registre suas Atividades.",
            icone: "📝",
            rota: `http://186.237.132.27:9033/m/?tipace=g&token=${user.toksim}&cpf=${user.cpffun}`,
            permissoes: ["F", "T"]
        },
        {
            titulo: "Acompanhar",
            descricao: "Acompanhar seus registros.",
            icone: "📊",
            rota: `http://186.237.132.27:9033/m/?tipace=i&token=${user.toksim}&cpf=${user.cpffun}`,
            permissoes: ["F", "T"]
        },
        {
            titulo: "Alteração de Foco",
            descricao: "Alterar seu foco de pontuação.",
            icone: "🎯",
            rota: "https://forms.cloud.microsoft/Pages/ResponsePage.aspx?id=n58bVyOXH0mZVSNA2rsaF0sAvGdHrsNCq5BSiFqfM7BUNFozMFhDNE5QVUtWN0dMWEJJMjdYREU0SS4u",
            permissoes: ["F", "T"]
        }

    ];

    const menusFiltrados = menus.filter(menu =>
        menu.permissoes.includes(user.tipfun)
    );

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.headerIcon}>🏆</div>
                <div className={styles.headerTexto}>
                    <h2>Engajamento</h2>
                    <p>Registro e consultas das ações de engajamento</p>
                </div>
            </div>

            <div className={styles.grid}>
                {menusFiltrados.map((item, index) => (
                    <div
                        key={index}
                        className={styles.card}
                        onClick={() => abrirLink(item.rota)}
                    >
                        <div className={styles.icon}>{item.icone}</div>

                        <div className={styles.info}>
                            <h4>{item.titulo}</h4>
                            <span>{item.descricao}</span>
                        </div>

                        <div className={styles.arrow}>›</div>
                    </div>
                ))}
            </div>
            <BottomNav />
        </div>
    );
}
